<template>
    <b-form id="data_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Дата"
                              label-for="title">
                    <datepicker input-class="form-control"
                                class="date"
                                :language="ru"
                                v-model="form.date"
                                :disabledDates="disabledDates"
                                placeholder=""></datepicker>
                    <span class="alert-danger" v-if="submitted && !form.date">Внесите дату</span>
                </b-form-group>
                <b-form-group label="Оффер">
                    <v-select :options="options" :filterable="false"
                              v-model="form.offer_id"
                              @search="onSearch">
                        <template slot="no-options">
                            Введите символы...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.id }}
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                ({{ option.id }})
                                {{ option.title }}
                            </div>
                        </template>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.offer_id">Выберите оффер</span>
                </b-form-group>
                <b-form-group v-if="this.$currentUser.department === 'adkey'" label="Приложение">
                  <b-form-select
                    required
                    size="sm"
                    :options="applicationOwnerOptions"
                    v-model="form.application_owner"
                  >
                  </b-form-select>
                  <span class=" alert-danger" v-if="submitted && !form.application_owner">Приложение</span>
                </b-form-group>
                <b-form-group label="ID партнёра">
                    <b-form-input class="insertInput"
                                  type="number"
                                  v-model="form.partner_id">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.partner_id">ID партнёра</span>
                </b-form-group>


                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Subid-1">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.sub1">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Subid-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.sub2">
                            </b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Subid-3">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.sub3">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Subid-4">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.sub4">
                            </b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group label="Источник">
                    <v-select :options="sourcesOptions" :filterable="false"
                              v-model="form.source_id"
                              @search="onSourcesSearch">
                        <template slot="no-options">
                            Введите символы...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.id }}
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.title }}
                            </div>
                        </template>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.source_id">Выберите источник</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Расход">
                    <b-form-input class="insertInput"
                                  type="number"
                                  step="any"
                                  v-model="form.expense">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.expense">Введите расход</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Валюта расхода">
                    <v-select :options="currency"
                              v-model="form.expense_currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && !form.expense_currency">Выберите валюту расхода</span>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-form-group label="Ставка партнера">
                    <b-form-input class="insertInput"
                                  type="text"
                                  v-model="form.partners_rate">
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-form-group label="Лиды">
                    <b-form-input
                            type="number"
                            v-model="form.leads_count">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.leads_count">Введите количество лидов</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Ставка">
                    <b-form-input class="insertInput"
                                  type="number"
                                  step="any"
                                  v-model="form.lead_rate">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.lead_rate">Введите ставку.</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Валюта ставки">
                    <v-select :options="currency"
                              v-model="form.lead_currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.lead_currency">Введите валюту ставки.</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Скидка,%">
                    <b-form-input
                            max="100"
                            type="number"
                            step="any"
                            v-model="form.discount">
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-6" style="margin-bottom: 0.5rem">
                <b-form-group label="Тест">
                    <b-form-checkbox v-model="form.is_test"
                                     value="1"
                                     unchecked-value="0" name="check-button">
                    </b-form-checkbox>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-dropdown right variant="primary" split text="Сохранить и выйти" v-on:click="onSubmit($event, true)"
                            class="float-right">
                    <b-dropdown-item v-on:click="onSubmit($event, true)">Сохранить и выйти</b-dropdown-item>
                    <b-dropdown-item v-on:click="onSubmit($event, false)">Сохранить и создать</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService'
    import SourcesService from '../../../services/sourcesDataService'
    import Datepicker from 'vuejs-datepicker'
    import DataService from '../../../services/dataDataService'
    import {ru} from '../../../services/customLocaleDatepicker'

    export default {
        name: 'CreateDataModal',
        components: {
            OffersService: OffersService,
            Datepicker: Datepicker
        },
        data() {
            return {
                defaultDate: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
                disabledDates: {
                    ranges: [{
                        from: new Date(1970, 1, 1),
                        to: new Date(this.$editDate)
                    }]
                },
                ru: ru,
                currency: [],
                sourcesOptions: [],
                options: [],
                submitted: false
            }
        },
        props: {
            form: {
                default: function () {
                    return {
                        date: this.defaultDate >= new Date(this.$editDate) ? this.defaultDate : this.$editDate,
                        offer_id: '',
                        application_owner: null,
                        sub1: '',
                        sub2: '',
                        sub3: '',
                        sub4: '',
                        source_id: '',
                        expense: '',
                        expense_currency: '',
                        partners_rate: '',
                        leads_count: '',
                        lead_rate: '',
                        lead_currency: '',
                        partner_id: '',
                        discount: 0,
                        is_test: 0
                    }
                }
            },
          applicationOwnerOptions: []
        },
        methods: {
            onSubmit(evt, close) {
                evt.preventDefault();
                this.submitted = true;

                if (!this.form.date || !this.form.offer_id || !this.form.source_id
                  || !this.form.expense || !this.form.expense_currency || !this.form.leads_count
                  || !this.form.lead_rate || !this.form.lead_currency || !this.form.partner_id
                  || (this.$currentUser.department === 'adkey' && !this.form.application_owner )) {
                    evt.preventDefault();

                    return;
                }

                DataService.save([this.form])
                    .then(function (response) {
                        if (close && response) {
                            window.location.href = '/data';
                        } else if (!close && response) {
                            this.form = {
                                date: this.defaultDate >= new Date(this.$editDate) ? this.defaultDate : this.$editDate,
                                offer_id: '',
                                application_owner: null,
                                sub1: '',
                                sub2: '',
                                sub3: '',
                                sub4: '',
                                source_id: '',
                                expense: '',
                                expense_currency: '',
                                partners_rate: '',
                                leads_count: '',
                                lead_rate: '',
                                lead_currency: '',
                                partner_id: '',
                                discount: 0,
                                is_test: 0
                            }
                            this.submitted = false;
                        }
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            onSearch(search, loading) {
                if (!search) {

                    return;
                }
                loading(true);

                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    start: null,
                    end: null
                }
                let user = null;

                OffersService.getDataSelectOffers(1, sort, search, range, user)
                    .then(function (response) {
                        let options = [];
                        response.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.options = options;
                        loading(false);
                    }.bind(this), 350)
            },
            onSourcesSearch(search, loading) {
                if (!search) {

                    return;
                }
                loading(true);

                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    start: null,
                    end: null
                }
                let user = null;

                SourcesService.getSources(1, sort, search, range, user)
                    .then(function (response) {
                        let options = [];
                        response.data.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.sourcesOptions = options;
                        loading(false);
                    }.bind(this), 350)
            },
        },
        beforeMount() {
            this.getCurrency();
        }
    }
</script>
<style>
    .vdp-datepicker input {
        background-color: white !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/CreateDataModal.vue